import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import PromotionModalComponent from './js/promotion-modal.component';

ComponentsFactory.getInstance().define('promotion-modal', PromotionModalComponent);
